import Beleg from '../Kosten/beleg';

export default class OPNV {
    constructor(
        active = false,
        summe = 0,
        belege = []
    ) {
        this.active = active;
        this.summe = parseFloat(summe).toFixed(2) || 0;
        this.belege = belege instanceof Array ? belege.map(item => {
            return item instanceof Beleg ? item : new Beleg(item.id, item.abrechnungId, item.filename, item.name, item.beschreibung, item.url, item.type);
        }) : [];
        this.upload = []
    }

    getSumme() {
        if(!this.summe || isNaN(this.summe)) {
            return '0.00';
        }
        return parseFloat(this.summe).toFixed(2);
    }

    toFirestore() {
        return {
            active: this.active || false,
            summe: this.getSumme(),
            belege: this.belege.map(beleg => {
                return beleg.toFirestore();
            }) || [],
        };
    }
}